import { useEffect } from 'react';

// Allguth ships a fixed brand palette (no tenant-driven color injection, light mode only).
const allguthColorLibrary = {
  '--color-bg-body': '#fff',
  '--color-brand-default': '#1a2a53',
  '--color-brand-hover': '#515c79',
  '--color-brand-pressed': '#142142',
  '--color-brand-loading': '#515c79',
  '--color-overlay-brand-focused': 'rgba(26, 42, 83, 16%)',
  '--color-overlay-brand-hover': 'rgba(26, 42, 83, 8%)',
  '--color-overlay-brand-pressed': 'rgba(26, 42, 83, 12%)',
  '--color-danger-default': '#e30040',
  '--color-danger-hover': '#e30040',
  '--color-danger-pressed': '#b50033',
};

const useColorTheme = () => {
  useEffect(() => {
    for (const [key, value] of Object.entries(allguthColorLibrary)) {
      document.body.style.setProperty(key, value);
    }
  }, []);
};

export default useColorTheme;
